import styled from 'styled-components';

export const FooterStyled = styled.footer`
    
    margin:0;
    bottom:0;
    padding:250px;
    background-color:#16151A;
    height:100%;
    width:100%;
    padding:30px;
    margin-top:${({ needMargin }) => (needMargin ? '100px' : '')}
`;
